export class CodeTransformer {
  static transform(obj) {
    let code = {};
    code.id = obj.id;
    code.code = obj.attributes.code;
    code.name = obj.attributes.name;
    code.group = obj.attributes.group;
    code.status = obj.attributes.status;
    code.color = obj.attributes.color;
    code.type = obj.attributes.type;
    code.typeColor = obj.attributes.type_color;
    code.complex = obj.attributes.complex;
    code.attributes = obj.attributes.attributes || [];
    code.data = obj.attributes.data;
    code.archived_at = obj.attributes.archived_at;
    return code;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/codes/code.transformer.js